// Scroll progress with "back to the top": the ring fills while the page is read, the arrow appears once the page is
// scrolled and leads back to the very top. There may be two: the big one at the bottom right
// (partials/page/scroll-progress.html.twig) and the small one at the end of the section rail of a one page
// (partials/page/section-rail.html.twig), which replaces the big one from lg on. The jump follows scroll-behavior of html
// (smooth, unless the visitor asked for less motion).
const RING_LENGTH = 2 * Math.PI * 49; // the circle of the path, r = 49

export default function () {
    const elements = [...document.querySelectorAll('.scroll-progress')];
    if (!elements.length) {
        return;
    }

    const paths = elements.map((element) => element.querySelector('path')).filter(Boolean);
    paths.forEach((path) => {
        const length = path.getTotalLength() || RING_LENGTH;
        path.dataset.length = String(length);
        path.style.strokeDasharray = `${length} ${length}`;
        path.style.strokeDashoffset = String(length);
    });

    const update = () => {
        const scroll = window.scrollY;
        const height = document.documentElement.scrollHeight - window.innerHeight;
        const share = height > 0 ? Math.min(scroll / height, 1) : 0;
        paths.forEach((path) => {
            path.style.strokeDashoffset = String(parseFloat(path.dataset.length) * (1 - share));
        });
        elements.forEach((element) => element.classList.toggle('active', scroll > 50));
    };

    update();
    window.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update, {passive: true});

    elements.forEach((element) => element.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({top: 0});
    }));
}
